import { FC } from "react";
import styled from "styled-components";
import { HeaderLinkNew } from "./HeaderLinkNew";
import { useAuthGuard } from "../../auth";
import { UserRole } from "../../../generated/graphql";
import useTranslateMessage from "../../../hooks/useTranslateMessage";

const StyledHeaderNavigationNew = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  & > * + * {
    margin-inline-start: 8px;
  }
`;

interface Props {}

const HeaderNavigationNew: FC<Props> = () => {
  const { isRole, isAllowed } = useAuthGuard([
    UserRole.CatalogManager,
    UserRole.SystemAdmin,
  ]);
  const t = useTranslateMessage();

  const isAdminRole = isRole(UserRole.SystemAdmin);
  const isOrderModeratorRole = isRole(UserRole.OrderModerator);

  return (
    // In RTL flex, the first DOM child renders nearest the logo (to its
    // immediate left) — order these to match the design, closest-to-logo first.
    <StyledHeaderNavigationNew>
      {/* Requisition Management */}
      <HeaderLinkNew href="/requisitions">
        {t({ id: "requisitionsview-title" })}
      </HeaderLinkNew>
      {/* Order Management */}
      <HeaderLinkNew href="/orders">
        {t({ id: "ordersview-title" })}
      </HeaderLinkNew>
      {isOrderModeratorRole && (
        <>
          {/* Company settings */}
          <HeaderLinkNew href="/my-company">
            {t({ id: "HeaderNavigation-companySettings" })}
          </HeaderLinkNew>
          {/* Company catalog */}
          <HeaderLinkNew href="/company-catalog">
            {t({ id: "companycatalog-171,36" })}
          </HeaderLinkNew>
        </>
      )}
      {/* Catalog */}
      {isAllowed && (
        <HeaderLinkNew href="/catalog">
          {t({ id: "header-catalog" })}
        </HeaderLinkNew>
      )}
      {/* Companies Table */}
      {isAdminRole && (
        <HeaderLinkNew href="/companies">
          {t({ id: "header-companies" })}
        </HeaderLinkNew>
      )}
      {/* Workflows */}
      {isAdminRole && (
        <HeaderLinkNew href="/workflows">
          {t({ id: "header-workflows" })}
        </HeaderLinkNew>
      )}
      {/* Reports */}
      <HeaderLinkNew href="/reports">
        {t({ id: "header-reports" })}
      </HeaderLinkNew>
    </StyledHeaderNavigationNew>
  );
};

export { HeaderNavigationNew };
